export default "__VITE_ASSET__CuBYkDQv__"